"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _svg = _interopRequireDefault(require("./svg"));

require("./checkbox.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Checkbox = function Checkbox(props) {
  var name = props.input ? props.input.name : props.name;
  var value = props.input ? props.input.value : props.value; // Handle both redux-form controlled and non-react form controlled check boxes
  // if its not a redux-form controlled and you don't pass 'onChange' it does nothing

  var handleChange;

  if (props.input) {
    handleChange = props.input.onChange;
  } else if (props.onChange) {
    handleChange = function handleChange(event) {
      var target = event.target;
      props.onChange(target.type === 'checkbox' ? target.checked : target.value);
    };
  }
  /* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */


  return _react["default"].createElement("div", {
    className: "Checkbox ".concat(name, " ").concat(props.className)
  }, _react["default"].createElement("label", null, _react["default"].createElement("input", _extends({
    type: "checkbox"
  }, props.input || props, {
    checked: value,
    onChange: handleChange
  })), _react["default"].createElement("span", {
    className: "box"
  }, _react["default"].createElement(_svg["default"], {
    id: "checkmark"
  })), props.label));
};

Checkbox.propTypes = {
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  label: _propTypes["default"].string,
  value: _propTypes["default"].bool,
  input: _propTypes["default"].object,
  // eslint-disable-line
  className: _propTypes["default"].string
};
Checkbox.defaultProps = {
  label: '',
  name: null,
  onChange: null,
  className: '',
  value: false
};
var _default = Checkbox;
exports["default"] = _default;